import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.scss';

export const Footer: React.FC = () => {
  return (
    <footer className="app-footer">
      <div className="footer-container">
        <div className="footer-brand">
          <div className="logo">
            <div className="logo-icon">
              <div className="icon-layers">
                <div className="layer-back"></div>
                <div className="layer-middle"></div>
                <div className="layer-front"></div>
              </div>
              <div className="icon-spark">✦</div>
            </div>
            <span className="logo-text">Odyssey</span>
          </div>
        </div>

        <div className="footer-links">
          <Link to="/contact" className="footer-link">
            Contact
          </Link>
          <Link to="/privacy" className="footer-link">
            Privacy
          </Link>
          <Link to="/terms" className="footer-link">
            Terms
          </Link>
        </div>

        <div className="footer-copyright">© 2025 Odyssey</div>
      </div>
    </footer>
  );
};
